module.exports = __webpack_public_path__ + "img/01_DSC7469-min.ff366784.jpg";